import React, { useState, useEffect, useContext } from 'react';
import Table from 'react-bootstrap/Table';
import moment from 'moment';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { AccordionContext } from 'react-bootstrap';


import messages from '../../locale/messages';

import upArrow from '/public/Icons/up.svg';
import downArrow from '/public/Icons/down.svg';

import s from './ViewBookingDetails.css';

function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <button
            type="button"
            onClick={decoratedOnClick}
            className={cx(s.ViewScheduleBookingAccordionHeader, 'viewScheduleBookingAccordionPrintHeader', isCurrentEventKey && s.ViewScheduleBookingAccordionHeaderRadius)}
        >
            {children}
            <div className={cx(s.ViewScheduleBookingAccordionArrow, 'svgImg')}>
                <img src={isCurrentEventKey ? upArrow : downArrow} alt="accordionaArrow" />
            </div>
        </button>
    );
}

const ViewScheduleBookingHistory = ({ data = [] }) => {
    const [load, setLoad] = useState(true);
    const { formatMessage, locale } = useIntl();

    useEffect(() => {
        setLoad(false);
        clearTimeout(loadSync);
        let loadSync = setTimeout(() => {
            setLoad(true);
        }, 1);

        return () => clearTimeout(loadSync); // Cleanup timeout on component unmount
    }, [locale]);
    let tableHeaders, header;

    tableHeaders = [messages.scheduledFrom, messages.scheduledTo, messages.status, messages.updatedAt];
    header = formatMessage(messages.scheduleBookingHistory);
    return (
        <div>
            {load && (
                <div>
                    <Accordion>
                        <ContextAwareToggle eventKey="0">{header}</ContextAwareToggle>
                        <Accordion.Collapse eventKey="0">
                            <div className='viewBookingInnerTableOuterContainer' >
                                <Table className='viewBookingInnerTableContainer'>
                                    <thead>
                                        <tr>
                                            {tableHeaders.map((header, index) => (
                                                <th scope="col" key={index}>
                                                    {formatMessage(header)}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.length > 0 ? (
                                            data.map((item, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        {item.scheduleFrom ? moment(parseInt(item.scheduleFrom)).format('DD-MM-YYYY HH:mm:ss') : item.scheduleFrom}
                                                    </td>
                                                    <td>
                                                        {item.scheduleTo ? moment(parseInt(item.scheduleTo)).format('DD-MM-YYYY HH:mm:ss') : item.scheduleTo}
                                                    </td>
                                                    <td>{item.status}</td>
                                                    <td>
                                                        {item.updatedAt ? moment(parseInt(item.updatedAt)).format('DD-MM-YYYY HH:mm:ss') : item.updatedAt}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} className='tableNoRecordCel'>
                                                    {formatMessage(messages.noResult)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion.Collapse>
                    </Accordion>
                </div>
            )}
        </div>
    );
};

export default withStyles(s)(ViewScheduleBookingHistory);